import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

export const ShieldTickIcon = (props: SVGProps) => {
  return <SpriteIcon spriteId="shield-tick" {...props} />;
};
